import _ from "lodash";
import ACLStorage from "lib/aclService";
import { CAN_VIEW_STUDENT_PROFILE } from "Constants/permissionConstants";
import { getIsTeacherAssociatedWithStudentFromCache } from "StudentPortfolio/modules/StudentPortfolioGraphqlHelpers";

export const getCanAccessProfileV2 = ({ userType }) => {
  return (
    userType === "student" &&
    ACLStorage.getModuleSettingsValue(CAN_VIEW_STUDENT_PROFILE)
  );
};

export const getFamilyCanAccessStudentProfile = ({ userType }) => {
  return (
    userType === "parent" &&
    ACLStorage.getModuleSettingsValue(CAN_VIEW_STUDENT_PROFILE)
  );
};

export const isStudentAChild = ({ childrenData, studentId }) => {
  return _.includes(
    _.map(childrenData.children, child => child.id),
    studentId
  );
};

export const getIsStaffAssociatedWithStudent = ({
  studentId,
  academicYearId,
}) => {
  if (!studentId || !academicYearId) {
    return false;
  }

  const {
    teacherStudentAssociationData,
  } = getIsTeacherAssociatedWithStudentFromCache({
    input: {
      studentIds: [studentId],
      academicYearId,
    },
  });

  const teacherStudentAssociationStatus = _.find(
    teacherStudentAssociationData,
    { studentId }
  );

  return _.get(teacherStudentAssociationStatus, "isAssociated", false);
};
